import { ManagerProgression } from '@sorare/core/src/__generated__/globalTypes';

export const computeLevelsToAnimate = (
  from: Pick<
    ManagerProgression,
    'levelReached' | 'points' | 'pointsForNextLevel'
  >,
  to: Pick<ManagerProgression, 'levelReached' | 'points' | 'pointsForNextLevel'>
) => {
  return Array.from({ length: to.levelReached - from.levelReached + 1 }).map(
    (_, index, array) => {
      let fromPart;
      if (from.levelReached === from.levelReached + index) fromPart = from;
      else
        fromPart = {
          levelReached: from.levelReached + index,
          points: 0,
          pointsForNextLevel:
            to.levelReached === from.levelReached + index
              ? to.points + to.pointsForNextLevel
              : 100,
        };

      let toPart;
      if (to.levelReached === from.levelReached + index) toPart = to;
      else
        toPart = {
          levelReached: from.levelReached + index,
          points:
            from.levelReached === from.levelReached + index
              ? from.points + from.pointsForNextLevel
              : 100,
          pointsForNextLevel: 0,
        };

      return {
        from: fromPart,
        to: toPart,
        levelUp:
          index === array.length - 1 && from.levelReached !== to.levelReached,
      };
    }
  );
};
